import React, { Component } from "react";
import axios from 'axios';

import ViewNavigation from './ViewNavigation.js';
import ViewPanel from './ViewPanel.js';

import * as Constants from "./Constants.js";

const queryString = require('query-string');

class View extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      brandTitle: "epilogos Search",
      brandSubtitle: "perform motif discovery for chromatin state sequences",
      viewPanelKey: Date(),
      dataState: "loading",
      description: "",
      dataURL: "",
      archiveURL: "",
      uuid: "",
    }
    this.bottomHalfContainer = React.createRef();
  }
  
  componentDidMount() {
    let query = queryString.parse(window.location.search);
    if ('id' in query) {
      let self = this;
      console.log(`retrieving job for ID ${query.id}`);
      axios.post('../assets/services/retrieveJob.py', { id : query.id })
        .then(function(response) {
          let jobMetadata = response.data;
          console.log("jobMetadata", jobMetadata);
          var dataURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.html';
          var archiveURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/epilogos-meme.' + jobMetadata['id'] + '.tbz2';
          console.log("dataURL", dataURL);
          //
          // check if meme.html exists (200); proceed load state data if so, else set view panel content to something else
          //
          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', dataURL, true); // asynchronous
          xhr.onreadystatechange = function() {
            if (this.readyState === 4) {
              if (this.status === 200) {
                self.setState({
                  uuid : jobMetadata['id'],
                  description : jobMetadata['description'],
                  dataState : "valid",
                  dataURL : dataURL,
                  archiveURL : archiveURL,
                  viewPanelKey : Date(),
                })
              }
              else {
                console.log("this.status", this.status);
                self.setState({
                  description : "",
                  dataState : "invalid",
                  viewPanelKey : Date()
                })
              }
            }
            else {
              console.log("this.readyState", this.readyState);
            }
          };
          xhr.send(null);
        })
        .catch(function(error) {
          console.log(error);
          if (error.response) {
            console.log(JSON.stringify(error.response.data));
            console.log(error.response.status);
            console.log(error.response.headers);
            switch (error.response.status) {
              case 400:
              case 403:
              case 404:
                self.setState({
                  description : "",
                  dataState : "invalid",
                  viewPanelKey : Date()
                })
                break;
              default:
                break;
            }
          }
        })
    }
    else {
/*
      console.log("Redirecting to front page...");
      window.location.href = Constants.rootURL;
*/
    }
  }

  render () {
    return (
      <div className="App">
        <div className="parent-container-navigation">
          <ViewNavigation 
            key={this.state.navbarKey}
            brandTitle={this.state.brandTitle}
            brandSubtitle={this.state.brandSubtitle}
            description={this.state.description}
            archiveURL={this.state.archiveURL}
            uuid={this.state.uuid} />
          <div style={{paddingTop:"65px"}}>
            <ViewPanel 
              key={this.state.viewPanelKey}
              id="viewer-container"
              dataState={this.state.dataState}
              dataURL={this.state.dataURL} />
          </div>
        </div>
      </div>
    );
  }
}

export default View;